<agpr-dialog-container
    [id]="'mentionSavingLimitExceededDialog'"
    class="agpr-mentionSavingLimitExceededDialog"
    heading="Monitoring.result.mentionSavingLimitExceed.heading"
    (close)="cancel()"
>
    <div class="agpr-mentionSavingLimitExceededDialog-wrapper">
        <agpr-message [severity]="messageSeverityEnum.error">
            {{ 'Monitoring.result.mentionSavingLimitExceed.errorBanner' | localize }}
        </agpr-message>
        <div [innerHTML]="'Monitoring.result.mentionSavingLimitExceed.messageHtml' | localize"></div>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            id="monitoringSearch.backfillDialog.cancel"
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            id="monitoringSearch.backfillDialog.ok"
            [style]="buttonTypes.primary"
            label="Monitoring.result.mentionSavingLimitExceed.actionButton"
            (click)="confirm()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>